<template>
  <div id="afdc-footer-actions" class="afdc-clearfix">
    <ul>
      <template v-if="$store.getters.localeCountry !== 'CA'">
        <li class="afdc-kiosk-mode-hide afdc-footer-actions-app">
          <a href="https://itunes.apple.com/us/app/alternative-fueling-station/id718577947">
            <font-awesome-icon v-bind:icon="['fab', 'apple']" class="afdc-fa-icon"/><span>{{ $t('iPhone App') }} <small>{{ $t('for U.S. stations') }}</small></span>
          </a>
        </li>
        <li class="afdc-kiosk-mode-hide afdc-footer-actions-app">
          <a href="https://play.google.com/store/apps/details?id=gov.energy.afdc.stationlocator">
            <font-awesome-icon v-bind:icon="['fab', 'android']" class="afdc-fa-icon"/><span>{{ $t('Android App') }} <small>{{ $t('for U.S. stations') }}</small></span>
          </a>
        </li>
      </template>
      <li class="afdc-kiosk-mode-hide">
        <a href="https://developer.nrel.gov/docs/transportation/alt-fuel-stations-v1/">
          <font-awesome-icon icon="database" class="afdc-fa-icon"/><span>{{ $t('Developer APIs') }}</span>
        </a>
      </li>
      <li class="afdc-kiosk-mode-hide" v-if="!corridorsTab">
        <a href="#" v-on:click.prevent="toggleEmbedForm">
          <font-awesome-icon icon="code" class="afdc-fa-icon"/><span>{{ $t('Embed Tool') }}</span>
        </a>
      </li>
      <li class="afdc-kiosk-mode-hide">
        <router-link v-bind:to="{ name: 'StationNew' }">
          <font-awesome-icon icon="plus-circle" class="afdc-fa-icon"/><span>{{ $t('Submit New Station') }}</span>
        </router-link>
      </li>
      <li>
        <a href="#" v-on:click.prevent="toggleAboutTheData">
          <font-awesome-icon icon="info-circle" class="afdc-fa-icon"/><span>{{ $t('About the Data') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    corridorsTab() {
      return this.$store.getters.isNavActiveTabCorridors;
    },
  },

  watch: {
    '$route.query.show_embed': {
      immediate: true,
      handler: 'setEmbedModalOpen',
    },

    '$route.query.show_about': {
      immediate: true,
      handler: 'setAboutModalOpen',
    },
  },

  methods: {
    setEmbedModalOpen() {
      if (this.$route.query.show_embed === 'true') {
        this.$store.commit('setEmbedModalOpen', true);
      } else {
        this.$store.commit('setEmbedModalOpen', false);
      }
    },

    toggleEmbedForm() {
      this.$store.commit('setEmbedModalLinkClicked', true);
      if (this.$store.getters.getEmbedModalOpen) {
        this.$router.push({ query: { ...this.$route.query, show_embed: undefined } });
      } else {
        this.$router.push({ query: { ...this.$route.query, show_embed: 'true' } });
      }
    },

    setAboutModalOpen() {
      if (this.$route.query.show_about === 'true') {
        this.$store.commit('setAboutModalOpen', true);
      } else {
        this.$store.commit('setAboutModalOpen', false);
      }
    },

    toggleAboutTheData() {
      this.$store.commit('setAboutModalLinkClicked', true);
      if (this.$store.getters.getAboutModalOpen) {
        this.$router.push({ query: { ...this.$route.query, show_about: undefined } });
      } else {
        this.$router.push({ query: { ...this.$route.query, show_about: 'true' } });
      }
    },
  },
};
</script>

<style lang="scss">
#footer-actions {
  z-index: 20;
  position: relative;

  background-color: #fff;
  padding-top: 20px;

  .fa-icon {
    font-size: 20px;
    margin-right: 6px;
    vertical-align: middle;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    float: left;
    height: 30px;
    margin-right: 28px;
    margin-bottom: 20px;
    a {
      color: #666;

      span {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  li:last-child {
    margin-right: 0px;
  }

  li.footer-actions-app {
    a span {
      line-height: 100%;

      small {
        display: block;
        font-size: 10px;
        line-height: 100%;

        // Force long French translations to wrap, so all these labels can
        // still fit on one line.
        max-width: 100px;
      }
    }
  }
}
</style>
